export const toggleBox = (arg, option) => {
    let rootEl;
    if (typeof arg === 'string') {
        rootEl = document.querySelector(arg);
    }
    else {
        rootEl = arg;
    }
    if (rootEl) {
        return new ToggleBox(rootEl, option);
    }
    return null;
};
class ToggleBox {
    rootEl;
    mainEl;
    duration = 200;
    enterClass = 'enter';
    leaveClass = 'leave';
    isShow = false;
    timerID;
    on;
    constructor(rootEl, option) {
        this.rootEl = rootEl;
        if (this.rootEl) {
            this.mainEl = this.rootEl.querySelector('.box-toggle-main');
        }
        if (option) {
            if (option.isShow !== undefined) {
                this.isShow = option.isShow;
            }
            if (option.on !== undefined) {
                this.on = option.on;
            }
        }
    }
    open(duration) {
        this.toggle(true, duration);
    }
    close(duration) {
        this.toggle(false, duration);
    }
    toggle(isShow, duration) {
        if (!this.rootEl || !this.mainEl) {
            return;
        }
        clearTimeout(this.timerID);
        if (isShow !== undefined) {
            this.isShow = isShow;
        }
        else {
            this.isShow = !this.isShow;
        }
        if (duration === undefined) {
            duration = this.duration;
        }
        const removeClassName = this.isShow ? this.leaveClass : this.enterClass;
        const addClassName = this.isShow ? this.enterClass : this.leaveClass;
        this.rootEl.classList.remove(removeClassName);
        this.rootEl.classList.remove(`${removeClassName}-active`);
        this.rootEl.classList.remove(`${removeClassName}-done`);
        this.rootEl.classList.add(addClassName);
        if (!this.isShow) {
            this.rootEl.style.height = `${this.mainEl.offsetHeight}px`;
            if (this.on && this.on.beforeClose) {
                this.on.beforeClose();
            }
        }
        else {
            this.rootEl.style.height = '0';
            if (this.on && this.on.beforeOpen) {
                this.on.beforeOpen();
            }
        }
        // アクティブ化
        window.setTimeout(() => {
            if (this.rootEl) {
                this.rootEl.classList.add(`${addClassName}-active`);
                if (this.isShow) {
                    this.rootEl.style.height = `${this.mainEl?.offsetHeight}px`;
                }
                else {
                    this.rootEl.style.height = '0';
                }
            }
            // アニメーション終了
            this.timerID = window.setTimeout(() => {
                if (this.rootEl) {
                    this.rootEl.classList.remove(`${addClassName}-active`);
                    this.rootEl.classList.add(`${addClassName}-done`);
                }
            }, duration);
        }, 1);
    }
}
